import * as e from "react";
import r from "../lib/IconBase.es.js";
import m from "../defs/Palette.es.js";
const t = e.forwardRef((o, a) => /* @__PURE__ */ e.createElement(r, { ref: a, ...o, weights: m }));
t.displayName = "PaletteIcon";
const n = t;
export {
  n as Palette,
  t as PaletteIcon
};
